import { createSelector } from '@ngrx/store';
import { selectUserFeatureState } from '../reducers';

/* istanbul ignore next  */
export const selectLoggedInUser = createSelector(
  selectUserFeatureState,
  (state) => state.loggedInUser,
);

/* istanbul ignore next  */
export const selectUserBookings = createSelector(
  selectUserFeatureState,
  (state) => state.bookings,
);

/* istanbul ignore next  */
export const selectUserMfa = createSelector(
  selectUserFeatureState,
  (state) => state.mfa,
);

export const selectLoggedInUserCustomerNumber = createSelector(
  selectLoggedInUser,
  (user) => user?.customerNumber,
);
